import { memo, type ReactNode, useMemo, useRef } from 'react';
import { DndProvider } from 'react-dnd';

import { createHtml5BackendWithDeferredEndDrag } from '~/components/Shared/Drag/createHtml5BackendWithDeferredEndDrag';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type AirDndProviderProps = {
  children: ReactNode;
};

export const AirDndProvider = memo(({ children }: AirDndProviderProps) => {
  const { dndFixEnabled } = useTemporaryFeatureFlags();
  const dndFixEnabledRef = useRef(dndFixEnabled);
  dndFixEnabledRef.current = dndFixEnabled;

  const backend = useMemo(
    () => createHtml5BackendWithDeferredEndDrag({ isFixEnabled: () => dndFixEnabledRef.current }),
    [],
  );

  return <DndProvider backend={backend}>{children}</DndProvider>;
});

AirDndProvider.displayName = 'AirDndProvider';
